import { useCallback, useState } from 'react';
import { firstOfMonth, isoDate, todayUtc } from './dateUtils.js';

/**
 * Mode d'affichage (Liste | Calendrier) mémorisé par écran mobile
 * (`synolog.mobile.viewmode.<ecran>`). Le stockage peut être indisponible
 * (navigation privée, WebView restreinte) : lecture et écriture protégées,
 * repli sur « liste ».
 */
export const VIEW_MODES = ['list', 'calendar'];

const storageKey = (screen) => `synolog.mobile.viewmode.${screen}`;

export function readViewMode(screen) {
  try {
    const v = window.localStorage.getItem(storageKey(screen));
    return VIEW_MODES.includes(v) ? v : 'list';
  } catch {
    return 'list';
  }
}

export function writeViewMode(screen, mode) {
  try {
    window.localStorage.setItem(storageKey(screen), mode);
  } catch {
    /* stockage indisponible : le choix vaut pour la session seulement */
  }
}

/**
 * Curseur de la vue calendrier : mois affiché + jour sélectionné. Changer de
 * mois sélectionne aujourd'hui s'il en fait partie, sinon le 1er du mois.
 */
export function useMonthCursor() {
  const [month, setMonthState] = useState(() => firstOfMonth(todayUtc()));
  const [selectedIso, setSelectedIso] = useState(() => isoDate(todayUtc()));
  const setMonth = useCallback((m) => {
    const next = firstOfMonth(m);
    const today = todayUtc();
    setMonthState(next);
    setSelectedIso(
      firstOfMonth(today).getTime() === next.getTime() ? isoDate(today) : isoDate(next),
    );
  }, []);
  return { month, setMonth, selectedIso, setSelectedIso };
}
